<!-- @format -->

<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<app-warning-label
  textColor="#505050"
  [icon]="true"
  color="#E5EFFD"
></app-warning-label>
<div
  class="error_message"
  *ngIf="(secondPage && showCapital) || (secondExistingPage && showCapital)"
>
  <div>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99859 8.74987V11.8749M2.24588 14.6879C1.52473 15.9379 2.42687 17.4999 3.86998 17.4999H16.1272C17.5703 17.4999 18.4724 15.9379 17.7513 14.6879L11.6227 4.06497C10.9011 2.81428 9.09604 2.81428 8.37449 4.06497L2.24588 14.6879ZM9.99859 14.3749H10.0048V14.3811H9.99859V14.3749Z"
        stroke="#FB4037"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
  <div>
    <p>
      Please fill in the total shares capital
      <span (click)="editShares()">here</span> to edit the Shares Allocated.
    </p>
  </div>
</div>
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<div
  class="goBack"
  (click)="goBack()"
  *ngIf="(secondPage || eRadio === 'existing') && !modal.context.isEdit"
>
  <img src="assets/icons/chevron-right.svg" />
  <p>Go back</p>
</div>

<div
  class="content ui basic segment"
  [ngClass]="{ loading: pendingArr?.length }"
  style="padding: 0; margin: 0"
>
  <div class="scroll-wrapper ui basic segment" style="padding: 24px 20px">
    <div class="ui form" *ngIf="firstPage && eRadio !== 'existing'">
      <div class="section">
        <h2
          style="
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            color: #3f4395;
          "
        >
          How would you like to add an individual
        </h2>
        <div class="grouped fields">
          <div class="field" appMargin marginT="5">
            <sui-radio-button
              name="entity"
              value="existing"
              [(ngModel)]="eRadio"
              ><strong
                style="
                  font-family: Roboto;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 18.75px;
                  text-align: left;
                  color: #505050;
                "
                >Link existing individual
              </strong>
            </sui-radio-button>
          </div>
          <div class="field" appMargin marginT="5">
            <div>
              <sui-radio-button name="entity" value="new" [(ngModel)]="eRadio"
                ><strong
                  style="
                    font-family: Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 18.75px;
                    text-align: left;
                    color: #505050;
                  "
                  >Add a new individual</strong
                >
              </sui-radio-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="secondPage" class="ui form" [formGroup]="companyDirectorForm">
      <div
        style="
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          color: #3f4395;
        "
      >
        {{ typeId }}'s Information
      </div>
      <div class="ui divider"></div>
      <div class="image_container">
        <div *ngIf="!imageUrl" class="plus_box" (click)="uploader.click()">
          <img src="assets/icons/add_24px.svg" />
        </div>
        <div *ngIf="imageUrl" class="image_box" (click)="uploader.click()">
          <img [src]="imageUrl" alt="Uploaded Image" />
          <div class="cancel_icon">
            <i class="cancel icon" (click)="deleteImage($event)"></i>
          </div>
        </div>
        <input
          type="file"
          accept=".jpg, .jpeg, .png, .JPG, .JPEG"
          #uploader
          (change)="onFileChangeData($event)"
          placeholder="Browse for documents"
          onclick="value = null"
          style="display: none"
        />
        <p class="upload_photo_width">
          {{ fileNamePhoto ? fileNamePhoto : "Upload Photo here" }}
        </p>
      </div>
      <div
        *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
        class="required field"
        [ngClass]="displayFieldCss('shareCapital')"
      >
        <label>Total Share Capital</label>
        <!-- <input
          #input
          formControlName="shareCapital"
          type="text"
          placeholder="200,000,000,000,000"
          disabled
        /> -->
        <app-currencyfmt-number-input
          [placeholder]="'Total Share Capital'"
          formControlName="shareCapital"
          [disabled]="true"
        ></app-currencyfmt-number-input>
        <app-field-error-display
          [displayError]="isFieldValid('shareCapital')"
          errorMsg="Please enter Total Share Capital"
        >
        </app-field-error-display>
      </div>
      <div
        *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
        class="required field"
        [ngClass]="displayFieldCss('shareAllocated')"
      >
        <label>Shares Allocated</label>
        <!-- <input
          #input
          formControlName="shareAllocated"
          type="text"
          [ngClass]="{
            border_red: showCapital
          }"
          placeholder="1,000,000,000"
        /> -->
        <app-currencyfmt-number-input
          [placeholder]="'Share Allocated'"
          formControlName="shareAllocated"
          [ngClass]="{
            border_red: showCapital
          }"
        ></app-currencyfmt-number-input>
        <app-field-error-display
          [displayError]="isFieldValid('shareAllocated')"
          errorMsg="Please enter Shares Allocated"
        >
        </app-field-error-display>
      </div>
      <div
        *ngIf="affiliateTypeId === 'shareholder_type'"
        class="required field"
        [ngClass]="displayFieldCss('shareholding')"
      >
        <label>Percentage of Share Capital</label>
        <input
          *ngIf="!usePercentage"
          formControlName="shareholding"
          type="number"
          disabled
          appRestrictToGreaterThanZero
          placeholder="3%"
        />
        <input
          *ngIf="usePercentage"
          formControlName="shareholding"
          type="number"
          appRestrictToGreaterThanZero
          placeholder="3%"
        />
        <app-field-error-display
          [displayError]="isFieldValid('shareholding')"
          errorMsg="Please enter Percentage of Share Capital"
        >
        </app-field-error-display>
      </div>
      <div class="required field" [ngClass]="displayFieldCss('firstName')">
        <label>First Name</label>
        <input
          #input
          formControlName="firstName"
          type="text"
          placeholder="First Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('firstName')"
          errorMsg="Please enter  FirstName"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('lastName')">
        <label>Last Name</label>
        <input formControlName="lastName" type="text" placeholder="Last Name" />
        <app-field-error-display
          [displayError]="isFieldValid('lastName')"
          errorMsg="Please enter  LastName"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('middleName')">
        <label>Middlename</label>
        <input
          formControlName="middleName"
          type="text"
          placeholder="Middle Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('middleName')"
          errorMsg="Please enter Middle Name"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('gender')">
        <label>Gender</label>
        <select formControlName="gender" class="ui search dropdown">
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('gender')"
          errorMsg="Please select your Gender"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('nationalityId')">
        <label>Nationality</label>
        <select class="ui search dropdown" formControlName="nationalityId">
          <option
            *ngFor="let country of countries"
            value="{{ country?.countryCode }}"
          >
            {{ country?.countryName }}
          </option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('nationalityId')"
          errorMsg="Please select your Nationality"
        >
        </app-field-error-display>
      </div>

      <div
        class="required field"
        [ngClass]="displayFieldCss('countryOfOriginId')"
      >
        <label>Country of Origin</label>
        <select formControlName="countryOfOriginId" class="ui search dropdown">
          <option
            *ngFor="let country of countries"
            value="{{ country?.countryCode }}"
          >
            {{ country?.countryName }}
          </option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('countryOfOriginId')"
          errorMsg="Please select your Country of Origin"
        >
        </app-field-error-display>
      </div>

      <div
        class="required field"
        [ngClass]="displayFieldCss('nationalIdNumber')"
      >
        <label>National ID Number</label>
        <input
          formControlName="nationalIdNumber"
          type="text"
          placeholder="National ID Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('nationalIdNumber')"
          errorMsg="Please Enter National ID Number"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('address')">
        <label>Address</label>
        <input formControlName="address" type="text" placeholder="Address" />
        <app-field-error-display
          [displayError]="isFieldValid('address')"
          errorMsg="Please enter address"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('email')">
        <label>Email</label>
        <input formControlName="email" type="email" placeholder="Email" />
        <app-field-error-display
          [displayError]="isFieldValid('email')"
          errorMsg="Please enter a valid email"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('phoneNumber')">
        <label>Phone Number</label>
        <input
          formControlName="phoneNumber"
          type="text"
          placeholder="Phone Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('phoneNumber')"
          errorMsg="Please enter 11 digit phone number"
        >
        </app-field-error-display>
      </div>
      <div appMargin marginB="7"></div>
    </div>
    <div *ngIf="eRadio === 'existing'">
      <div
        style="
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          color: #3f4395;
        "
      >
        {{
          secondExistingPage
            ? "Individual’s Information"
            : "Select to link an existing individual"
        }}
      </div>
      <div class="ui divider"></div>
      <div class="show" *ngIf="!this.secondExistingPage">
        <div
          class="individual_container"
          *ngFor="let director of companyDirectors; let i = index"
        >
          <sui-checkbox
            style="width: 100%; display: flex; align-items: center"
            name="timer"
            class="new-timer"
            [(ngModel)]="director.checkbox"
            (ngModelChange)="onBoxChecked(director, $event)"
          >
            <div class="existing_individual">
              <div></div>
              <div class="image">
                <img
                  *ngIf="director.photographDocumentPath"
                  src="{{ baseUrl }}/public/image/?media={{
                    director?.photographDocumentPath
                  }}"
                />
                <img
                  *ngIf="!director.photographDocumentPath"
                  src="assets/avatar/1.jpg"
                />
              </div>
              <div class="information">
                <div>
                  <h1>{{ director?.firstName }} {{ director?.lastName }}</h1>
                </div>
                <div class="flex">
                  <img src="assets/icons/email.svg" />
                  <p>{{ director?.email }}</p>
                </div>
                <div class="flex">
                  <img src="assets/icons/outline-two.svg" />
                  <p>{{ director?.phoneNumber }}</p>
                </div>
              </div>
            </div></sui-checkbox
          >
        </div>
        <app-no-record-found
          *ngIf="companyDirectors && companyDirectors?.length < 1"
        ></app-no-record-found>
      </div>
      <div class="show_second" *ngIf="this.secondExistingPage">
        <div class="individual_container">
          <div
            style="width: 100%; display: flex; align-items: center"
            name="timer"
            class="new-timer"
          >
            <div class="existing_individual">
              <div></div>
              <div class="image">
                <img
                  *ngIf="getChosenExistingResult().photographDocumentPath"
                  src="{{ baseUrl }}/public/image/?media={{
                    getChosenExistingResult()?.photographDocumentPath
                  }}"
                />
                <img
                  *ngIf="!getChosenExistingResult().photographDocumentPath"
                  src="assets/avatar/1.jpg"
                />
              </div>
              <div class="information">
                <div>
                  <h1>
                    {{ getChosenExistingResult()?.firstName }}
                    {{ getChosenExistingResult()?.lastName }}
                  </h1>
                </div>
                <div class="flex">
                  <img src="assets/icons/email.svg" />
                  <p>{{ getChosenExistingResult()?.email }}</p>
                </div>
                <div class="flex">
                  <img src="assets/icons/outline-two.svg" />
                  <p>{{ getChosenExistingResult()?.phoneNumber }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui form" [formGroup]="companyDirectorForm">
          <div
            *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
            class="required field"
            [ngClass]="displayFieldCss('shareCapital')"
          >
            <label>Total Share Capital</label>
            <!-- <input
              #input
              formControlName="shareCapital"
              type="text"
              placeholder="200,000,000,000,000"
              disabled
            /> -->
            <app-currencyfmt-number-input
              [placeholder]="'Total Share Capital'"
              formControlName="shareCapital"
              [disabled]="true"
            ></app-currencyfmt-number-input>
            <app-field-error-display
              [displayError]="isFieldValid('shareCapital')"
              errorMsg="Please enter Total Share Capital"
            >
            </app-field-error-display>
          </div>
          <div
            *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
            class="required field"
            [ngClass]="displayFieldCss('shareAllocated')"
          >
            <label>Shares Allocated</label>
            <!-- <input
              #input
              formControlName="shareAllocated"
              type="text"
              [ngClass]="{
                border_red: showCapital
              }"
              placeholder="1,000,000,000"
            /> -->
            <app-currencyfmt-number-input
              [placeholder]="'Share Allocated'"
              formControlName="shareAllocated"
              [ngClass]="{
                border_red: showCapital
              }"
            ></app-currencyfmt-number-input>
            <app-field-error-display
              [displayError]="isFieldValid('shareAllocated')"
              errorMsg="Please enter Shares Allocated"
            >
            </app-field-error-display>
          </div>
          <div
            *ngIf="affiliateTypeId === 'shareholder_type'"
            class="required field"
            [ngClass]="displayFieldCss('shareholding')"
          >
            <label>Percentage of Share Capital</label>
            <input
              *ngIf="!usePercentage"
              formControlName="shareholding"
              type="number"
              disabled
              appRestrictToGreaterThanZero
              placeholder="3%"
            />
            <input
              *ngIf="usePercentage"
              formControlName="shareholding"
              type="number"
              appRestrictToGreaterThanZero
              placeholder="3%"
            />
            <app-field-error-display
              [displayError]="isFieldValid('shareholding')"
              errorMsg="Please enter Percentage of Share Capital"
            >
            </app-field-error-display>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="actions" style="background: inherit; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pendingArr?.length }"
    [disabled]="
      pendingArr?.length ||
      (!companyDirectorForm.valid &&
        secondPage &&
        eRadio === 'new' &&
        !selectedFilePhoto)
    "
    (click)="submit()"
    autofocus
  >
    {{ modal.context.isEdit ? "Update" : "Add" }}
  </button>
</div>
